import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpTokenInterceptor } from '../interceptor/token.interceptor';
import { LanguageInterceptor } from '../interceptor/language.interceptor';

// Fournisseur pour les intercepteurs HTTP - utilise l'approche fonctionnelle
export const httpInterceptorProviders = provideHttpClient(
  withInterceptors([LanguageInterceptor, HttpTokenInterceptor])
);
